export default {
  // data() {
  //   return {
  //     $oauth2: this.$oauth2
  //   }
  // },
  computed: {
    hasAccessToken: {
      get() {
        return this.$oauth2.hasAccessToken()
      }
    },
    isRegistered: {
      get() {
        return !this.$oauth2.isGuest()
      }
    },
    isGuest: {
      get() {
        return this.$oauth2.isGuest()
      }
    },
    isRoute: {
      get() {
        return this.$oauth2.storage.hasValue('chip-route-name', this.institutionId, this.customerId)
      }
    }

  },
  methods: {
    setRegistered() {
      // setRegistered(value = true) {
      // if (!value) {
      //   this.$oauth2.storage.removeValue('chip-reg-user', this.institutionId, this.customerId)
      // } else {
      //   this.$oauth2.storage.setValue('chip-reg-user', 1, this.institutionId, this.customerId)
      // }
    },
    setWelcomeFlag(value = true) {
      if (!value) {
        this.$oauth2.storage.removeValue('chip-welcome-flag', this.institutionId, this.customerId)
      } else {
        this.$oauth2.storage.setValue('chip-welcome-flag', 1, this.institutionId, this.customerId)
      }
    },
    isWelcomeFlag() {
      return this.$oauth2.storage.hasValue('chip-welcome-flag', this.institutionId, this.customerId)
    },
    getRoute() {
      return this.$oauth2.storage.getValue('chip-route-name', this.institutionId, this.customerId)
    },
    setRoute(value = null) {
      if (value) {
        this.$oauth2.storage.setValue('chip-route-name', value, this.institutionId, this.customerId)
      } else {
        this.$oauth2.storage.removeValue('chip-route-name', this.institutionId, this.customerId)
      }
    },
    getBasket() {
      return this.$oauth2.storage.hasValue('chip-bas-id', this.institutionId, this.customerId) ? this.$oauth2.storage.getValue('chip-bas-id', this.institutionId, this.customerId) : null
    },
    setBasket(value = null) {
      if (value) {
        this.$oauth2.storage.setValue('chip-bas-id', value, this.institutionId, this.customerId)
      } else {
        this.$oauth2.storage.removeValue('chip-bas-id', this.institutionId, this.customerId)
      }
    },
    signIn() {
      this.setRegistered(true)
      if (this.$route.meta.canLogin) {
        this.setRoute(this.$route.name)
      }
      this.$router.push({ name: 'login' }).catch(console.log)
    },
    signOut() {
      this.$router.push({ name: 'logout' }).catch(console.log)
    },
    toCustomer() {
      this.$router.push({ name: 'customer' }).catch(console.log)
    },
    toEshop() {
      this.$router.push({ name: 'eshop' }).catch(console.log)
    },
    toReservations() {
      this.$router.push({ name: 'reservations' }).catch(console.log)
    },
    toBasket() {
      this.$router.push({ name: 'basket' }).catch(console.log)
    },
    newAccount() {
      this.$fetch('approvable-apps').then(response => {
        const registration = response.find(app => app.institutionId === this.$institution.institution.institutionId && app.appName === 'Registrace')
        if (registration) {
          if (registration.redirectUri) {
            const redirectUri = registration.redirectUri.substr(0, registration.redirectUri.indexOf('#')) + '#/?lang=cz&nested=true'
            this.$iframe.iframe.width = '600px'
            this.$iframe.iframe.height = '700px'
            this.$iframe.iframe.scrolling = 'yes'
            this.$iframe.iframe.redirectUrl = redirectUri
          }
        }
      }).catch(console.log)
    }
  }
}
